// Campus photo for /colleges/university-of-arkansas: CC BY-SA 4.0, by Brandonrush, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main%2C_Summer_2015_002.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-arkansas/; credited under the photo.
const photo = {
    "slug": "university-of-arkansas",
    "alt": "Old Main and its clock tower behind a tree-lined walk on the University of Arkansas campus in Fayetteville",
    "src": "/colleges/university-of-arkansas/campus-1600.webp",
    "srcSmall": "/colleges/university-of-arkansas/campus-800.webp",
    "srcMid": "/colleges/university-of-arkansas/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-arkansas/og.jpg",
    "title": "Old Main, Summer 2015 002",
    "author": "Brandonrush",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main%2C_Summer_2015_002.jpg",
    "read": "2026-10-01"
};

export default photo;
